import React, { useEffect, useMemo, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import CustomBtn from '../CustomBtn/CustomBtn';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { useSelector } from 'react-redux';
import ar from 'date-fns/locale/ar';
import { toast } from 'react-toastify';
import imageCompression from "browser-image-compression";
import axios from 'axios';
import {  useParams } from 'react-router-dom';
import "./StudentDataContainer.css"

// تسجيل اللغة العربية لـ DatePicker
registerLocale('ar', ar);

// **********************************************
// ********* مكونات وهمية (يجب استبدالها) ********
// **********************************************
const CustomInput = ({ name, type = "text", placeholder, value }) => (
  <input
    type={type}
    name={name}
    value={value}
    // onChange={onChange}
    className='form-control bg-light border-0 rounded-3 mb-3'
    style={{ height: '50px' }}
    placeholder={placeholder}
    disabled
  />
);
function StudentDataContainer() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state.auth?.userArray?.user);
  const {list: items } = useSelector((state) => state.Students);
  const [category, setCategory] = useState('')
  const [subCategory, setSubCategory] = useState('')
  const { id } = useParams();

    const result = useMemo(() => {
    const grouped = {};
    items?.student_expenses?.data?.forEach((item) => {
      const studentId = item.student.id;
      if (!grouped[studentId]) {
        grouped[studentId] = {
          student: item.student,
          grade:item?.grade?.name,
          grade_category:item?.grade?.grade_category?.name,
          details: [],
          payments: [],
          amount_due: item.amount_due,
          cumulative_paid: item.cumulative_paid,
          expense_price: item.expense_price,
        };
      }
  
      grouped[studentId].payments.push({
        amount_paid: item.amount_paid,
        created_at: item.created_at,
        is_registration_fee: item.is_registration_fee,
        payment_type: item.details?.[0]?.name
      });
  
      item.details?.forEach((detail) => {
        const exists = grouped[studentId].details.find(d => d.name === detail.name);
        if (!exists) {
          grouped[studentId].details.push({ name: detail.name });
        }
      });
    });
  
    // عكس الدفعات لكل طالب
    Object.values(grouped).forEach(student => {
      student.payments.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      // لو عايزة بالعكس خالص:
      // student.payments.reverse();
    });
  
    return Object.values(grouped);
  }, [items.student_expenses]);
  
  const alldata = [...(result || []), ...(items?.recently_created_students || [])];console.log(alldata);

  const studentInf = alldata?.find((item) => item?.student?.id == id)?.student
  useEffect(() => {
  const getData=async()=>{
          try {
            const response = await axios.get(`https://nanosoft.space/taarteb/public/api/grades`, {
              // const response = await axios.get(`https://nanosoft.space/taarteb/public/api/grade-categories/${filterData[0]?.value}/grades`,{
              headers: {
                Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL25hbm9zb2Z0LnRlY2hub2xvZ3kvdGFhcnRlYi9hcGkvdXNlci9hdXRoL2xvZ2luIiwiaWF0IjoxNzYxOTA3NTE2LCJleHAiOjE3OTM0NDM1MTYsIm5iZiI6MTc2MTkwNzUxNiwianRpIjoiWEEyOUY5ZkpkRTR6TjVOSyIsInN1YiI6IjQ5IiwicHJ2IjoiZGRmMmI5ODg5ZTA2MmRkZTkzMmM4YWEwZTEwZjg4MDlkMjY0MmY1YyJ9.YmGuLW0CTDXwzfZq9G5f5LnO34EIx-KkbyxXvR0yjNU`
              }
            });            
            const filterGrades = response.data.data.data.find((item) => item?.id == studentInf?.grade_id)
setCategory(filterGrades?.name)    
setSubCategory(filterGrades?.category)    
            // const optionsRes = filterGrades.map(item => ({
            //   value: item.id,
            //   label: item.name
            // }));
    
            // setOptionsState(optionsRes);
          } catch (error) {
    
          } finally {
          }
  }
  getData()
  }, [])
  const [healthData, setHealthData] = useState({
    chronic: "",
    allergy: "",
    notes: "",
  });
  const [transportType, setTransportType] = useState(userinfo?.student ? userinfo?.student?.transport : "school_bus");
  const [governoratesState, setgovernoratesState] = useState([])

  const [educationalData, setEducationalData] = useState({
    skills: "", // مهارات مميزة للطالب
    prevStudy: currentLocal.home.No, // هل سبق له الدراسة؟
    prevSchoolData: "", // بيانات المدرسة السابقة
    recognizeLetters: currentLocal.home.No, // هل يميز الحروف بشكل عشوائي؟
    shortRead: currentLocal.home.Excellent, // يقرأ كلمات قصيرة
    longRead: currentLocal.home.Excellent, // يقرأ جمل قصيرة
    quranMemorization: currentLocal.home.No, // يحفظ سورا من القرآن
    edNotes: "", // ملاحظات تعليمية أخرى
  });
  const [relativeData, setRelativeData] = useState({
    name: "", relationship: "", phone: "",
  });
  const [fatherData, setFatherData] = useState({
    name: userinfo?.student?.name, nationality: "", civilId: "", phone: "", job: "", workplace: "", educationLevel: "",
  });

  const [motherData, setMotherData] = useState({
    name: "", nationality: "", civilId: "", phone: "", job: "", workplace: "", educationLevel: "",
  });
  const [studentData, setStudentData] = useState({
    civilId: userinfo?.student?.identity_number, name: userinfo?.student?.name, nameEn: userinfo?.student?.name_en, gender: userinfo?.student ? userinfo?.student?.gender == "f" ? "أنثي" : "ذكر" : "ذكر", siblingCount: userinfo?.student?.siblings_count, siblingOrder: userinfo?.student?.sibling_order, password: "", password_confirmation: ""
  });




  const [governoratId, setgovernoratId] = useState(userinfo?.student ? userinfo?.student?.region?.state?.governorate?.id : "")
  const [stateId, setstateId] = useState(userinfo?.student ? userinfo?.student?.region?.state?.id : "")
  const [regionId, setregionId] = useState(userinfo?.student ? userinfo?.student?.region?.id : "")
  const [addressData, setAddressData] = useState({
    streetNumber: userinfo?.student ? userinfo?.student?.street_number : "", houseNumber: userinfo?.student ? userinfo?.student?.house_number : "", nearestPlace: userinfo?.student ? userinfo?.student?.nearest_landmark : "", mapLink: userinfo?.student ? userinfo?.student?.home_location_url : "", governorates: ""
  });

  console.log(studentInf);
  const rows = [
    { key: "parent_identity_card_image", label: "البطاقة الشخصية / بطاقة الإقامة لولي الأمر", label_en: "Guardian’s ID / Residence Permit" },
    { key: "student_residence_card_image", label: "بطاقة الإقامة للطالب الوافد", label_en: "Student’s Residence Permit (for non-citizens)" },
    { key: "student_passport_image", label: "صورة جواز سفر الطالب", label_en: "Student’s Passport Copy" },
    { key: "student_health_card_image", label: "صورة البطاقة الصحية", label_en: "Health Card Copy" },
    { key: "image", label: "الصورة الشخصية للطالب", label_en: "Student’s Personal Photo" },
    { key: "student_birth_certificate_image", label: "صورة شهادة ميلاد الطالب", label_en: "Student’s Birth Certificate Copy" },
    { key: "home_map_image", label: "صورة خريطة المنزل", label_en: "Home Map Image" }
  ];
    const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Function to open the modal and set the image
  const openModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setShowModal(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };
  return (
    <div className='student_data_container'>
      <Container>
        <p className='text-danger'>{currentLocal.home.studentDataTitle}</p>
        <div className='my-3'>
          <Row>
            <Col md={4}><label>{currentLocal.home.studentCivilId}</label><CustomInput name="civilId" value={studentInf?.identity_number} /></Col>
            <Col md={4}><label>{currentLocal.home.studentNameAr}</label><CustomInput name="name" value={studentInf?.name} /></Col>
            <Col md={4}><label>{currentLocal.home.studentNameEn}</label><CustomInput name="nameEn" value={studentInf?.name_en!="undefined"?studentInf?.name_en:''} /></Col>

            <Col md={3}>
              <label htmlFor="genderSelect">{currentLocal.home.gender}</label>
              <CustomInput name="name" value={studentInf?.gender == "m" ? currentLocal.home.male : currentLocal.home.female} />

            </Col>

            <Col md={3}>
              <label>{currentLocal.home.birthDate} </label>
              <CustomInput value={String(studentInf?.birth_date)} />
            </Col>

            <Col md={3}><label>{currentLocal.home.Stage} </label>
              <CustomInput name="name" value={subCategory} />


            </Col>
            <Col md={3}><label>{currentLocal.home.grade} </label>
              <CustomInput name="name" value={category} />


            </Col>
            <Col md={3}><label>{currentLocal.home.siblingCount}</label><CustomInput type="number" name="siblingCount" value={studentInf?.siblings_count} /></Col>
            <Col md={3}><label>{currentLocal.home.siblingOrder}</label><CustomInput type="number" name="siblingOrder" value={studentInf?.sibling_order} /></Col>
            <Col md={3}><label>{currentLocal.home.passwordPlaceholder}</label><CustomInput type="number" name="siblingOrder" value={studentInf?.password} /></Col>
          </Row>
        </div>
        <h5 className='text-danger'>{currentLocal.home.fatherDataTitle}</h5>
        <div className='my-3'>
          <Row>
            <Col md={4}><label>{currentLocal.home.fatherName}</label><CustomInput name="name" value={studentInf?.parent?.parent_name} /></Col>
            <Col md={4}><label>{currentLocal.home.fatherNationality}</label><CustomInput name="nationality" value={studentInf?.parent.parent_nationality} /></Col>
            <Col md={4}><label>{currentLocal.home.fatherCivilId}</label><CustomInput name="civilId" value={studentInf?.parent.parent_identity_number} /></Col>
            <Col md={3}><label>{currentLocal.home.fatherPhone}</label><CustomInput name="phone" value={studentInf?.parent_phone} /></Col>
            <Col md={3}><label>{currentLocal.home.fatherJob}</label><CustomInput name="job" value={studentInf?.parent.parent_job} /></Col>
            <Col md={3}><label>{currentLocal.home.fatherWorkplace}</label><CustomInput name="workplace" value={studentInf?.parent.parent_job_address} /></Col>
            <Col md={3}><label>{currentLocal.home.fatherEducationLevel}</label><CustomInput name="educationLevel" value={studentInf?.parent.parent_education_level} /></Col>
          </Row>
        </div>
        <h5 className='text-danger'>{currentLocal.home.Mothersdata}</h5>
        <div className='my-3'>
          <Row>
            <Col md={4}><label>{currentLocal.home.Mothersname} </label><CustomInput name="name" value={studentInf?.parent.mother_name} /></Col>
            <Col md={4}><label>{currentLocal.home.Nationality} </label><CustomInput name="nationality" value={studentInf?.parent.mother_nationality} /></Col>
            <Col md={4}><label>{currentLocal.home.Civilnumber} </label><CustomInput name="civilId" value={studentInf?.parent.mother_identity_number} /></Col>
            <Col md={3}><label>{currentLocal.home.Motherphonenumber} </label><CustomInput name="phone" value={studentInf?.parent.mother_phone} /></Col>
            <Col md={3}><label>{currentLocal.home.role} </label><CustomInput name="job" value={studentInf?.parent.mother_job} /></Col>
            <Col md={3}><label>{currentLocal.home.Worklocation} </label><CustomInput name="workplace" value={studentInf?.parent.mother_job_address} /></Col>
            <Col md={3}><label>{currentLocal.home.Educationallevel}</label><CustomInput name="educationLevel" value={studentInf?.parent.mother_education_level} /></Col>
          </Row>
        </div>

        <div className='my-3'>
          <Row>
            <Col md={3}>
              <label>{currentLocal.home.parentStatus}</label>
              <CustomInput name="name" value={studentInf?.parent?.parents_status == "together" ? currentLocal.home.parentsTogether : studentInf?.parent?.parents_status == "separated" ? currentLocal.home.parentsSeparated : studentInf?.parent?.parents_status == "widower" ? currentLocal.home.parentsWidower : currentLocal.home.parentsWidow} />
            </Col>
            <Col md={3}><label>{currentLocal.home.relativeName}</label><CustomInput name="name" value={studentInf?.parent?.relative_name} /></Col>
            <Col md={3}><label>{currentLocal.home.relationship} </label><CustomInput name="relationship" value={studentInf?.parent.relative_relation} /></Col>
            <Col md={3}><label>{currentLocal.home.relativePhone}</label><CustomInput name="phone" value={studentInf?.parent.relative_phone} /></Col>
          </Row>
        </div>


        <h5 className='text-danger mt-5'>{currentLocal.home.BehavioralData}</h5>
        <div >
          <label>{currentLocal.home.DistinctiveSkills}</label>
          <textarea
            rows={6}
            className='w-100 form-control bg-light border-0 rounded-3 mb-3'
            name="skills"
            value={studentInf?.distinguished_skills}
            disabled

          ></textarea>

          <label className="form-label fw-bold mb-2">{currentLocal.home.StudentBehaviors}</label>
          <CustomInput name="phone"   value={studentInf?.behavioral_data?.join(", ")}/>
        </div>
        <h5 className='text-danger mt-5'>{currentLocal.home.Studenteducationaldata}</h5>
        <div >

          {/* هل سبق له الدراسة؟ */}
          <div className='d-flex align-items-center mb-3 section_container'>
            <p className='w-25 mb-0'>{currentLocal.home.studiedbefore}</p>
            <div className='mt-2'>
              <Form.Check type="radio" id="1" label={currentLocal.home.yes} name="prevStudy" value="1" checked={studentInf?.has_previous_education == "1"} disabled inline className='form-check-reverse mx-3' />
              <Form.Check type="radio" id="2" label={currentLocal.home.No} name="prevStudy" value="0" checked={studentInf?.has_previous_education == "0"} disabled inline className='form-check-reverse mx-3' />

            </div>
          </div>

          <label>{currentLocal.home.PreviousSchoolData}</label>
          <textarea
            rows={6}
            className='w-100 form-control bg-light border-0 rounded-3 mb-3'
            name="prevSchoolData"
            value={studentInf?.previous_school_data}
            disabled
          ></textarea>

          {/* هل يميز الحروف بشكل عشوائي؟ */}
          <div className='d-flex align-items-center mb-3 section_container'>
            <p className='w-25 mb-0'>{currentLocal.home.randomlyidentifyletters}</p>
            <div className='mt-2'>
              <Form.Check type="radio" id="3" label={currentLocal.home.yes} name="recognizeLetters" value="1" checked={studentInf?.can_distinguish_letters_randomly == "1"} disabled inline className='form-check-reverse mx-3' />
              <Form.Check type="radio" id="4" label={currentLocal.home.No} name="recognizeLetters" value="0" checked={studentInf?.can_distinguish_letters_randomly == "0"} disabled inline className='form-check-reverse mx-3' />
            </div>
          </div>
          <div className='d-flex align-items-center mb-3 section_container'>
            <p className='w-25 mb-0'>{currentLocal.home.readshortwords}</p>
            <Form.Check type="radio" id="5" label={currentLocal.home.Excellent} name="shortRead" value="excellent" checked={studentInf?.reads_short_words === "excellent"} disabled inline className='form-check-reverse mx-3' />
            <Form.Check type="radio" id="6" label={currentLocal.home.Verygood} name="shortRead" value="very_good" checked={studentInf?.reads_short_words === "very_good"} disabled inline className='form-check-reverse mx-3' />
            <Form.Check type="radio" id="7" label={currentLocal.home.Good} name="shortRead" value="good" checked={studentInf?.reads_short_words === "good"} disabled inline className='form-check-reverse mx-3' />
            <Form.Check type="radio" id="8" label={currentLocal.home.Doesnotread} name="shortRead" value="cannot_read" checked={studentInf?.reads_short_words === "cannot_read"} disabled inline className='form-check-reverse mx-3' />
          </div>

          {/* يقرأ جمل قصيرة؟ */}
          <div className='d-flex align-items-center mb-3 section_container'>
            <p className='w-25 mb-0'>{currentLocal.home.readshortsentences}</p>
            <Form.Check
              type="radio"
              id="9"
              label={currentLocal.home.Excellent}
              name="longRead"
              value="excellent"
              checked={studentInf?.reads_short_sentences === "excellent"}
              disabled inline
              className='form-check-reverse mx-3' />
            <Form.Check type="radio" id="10" label={currentLocal.home.Verygood} name="longRead" value="very_good" checked={studentInf?.reads_short_sentences === "very_good"} disabled inline className='form-check-reverse mx-3' />
            <Form.Check type="radio" id="11" label={currentLocal.home.Good} name="longRead" value="good" checked={studentInf?.reads_short_sentences === "good"} disabled inline className='form-check-reverse mx-3' />
            <Form.Check type="radio" id="12" label={currentLocal.home.Doesnotread} name="longRead" value="cannot_read" checked={studentInf?.reads_short_sentences === "cannot_read"} disabled inline className='form-check-reverse mx-3' />
          </div>
          <div className='d-flex align-items-center mb-3 section_container'>
            <p className='w-25 mb-0'>{currentLocal.home.surahsfromtheQuran}</p>
            <Form.Check type="radio" id="13" label={currentLocal.home.yes} name="quranMemorization" value="1" checked={studentInf?.memorizes_quran_surahs == "1"} disabled inline className='form-check-reverse mx-3' />
            <Form.Check type="radio" id="14" label={currentLocal.home.No} name="quranMemorization" value="0" checked={studentInf?.memorizes_quran_surahs == "0"} disabled inline className='form-check-reverse mx-3' />
          </div>
          <Form.Group as={Col} controlId="edNotes">
            <Form.Label className='w-100'>{currentLocal.home.Othereducationalnotes}</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="edNotes"
              value={studentInf?.additional_educational_notes}
              disabled
              className="bg-light border-0 rounded-3"
            />
          </Form.Group>
        </div>

        <div className='mt-5'>
          <h5 className='text-danger'>{currentLocal.home.Healthcondition}</h5>

          {/* سلامة النطق */}
          <div className="d-flex justify-content-start mb-4 gap-4 align-items-center form-check form-check-reverse section_container">
            <Form.Label className="fw-bold mb-0 w-25">{currentLocal.home.Pronunciationcorrectness}</Form.Label>
            <Form.Check className='p-0' id="pronunciation1" type="radio" label={currentLocal.home.Excellent} name="speech" value="excellent" checked={studentInf?.pronunciation == "excellent"} disabled inline />
            <Form.Check className='p-0' id="pronunciation2" type="radio" label={currentLocal.home.Good} name="speech" value="good" checked={studentInf?.pronunciation == "good"} disabled inline />
            <Form.Check className='p-0' id="pronunciation3" type="radio" label={currentLocal.home.Needsfollowup} name="speech" value="needs_follow_up" checked={studentInf?.pronunciation == "needs_follow_up"} disabled inline />
          </div>

          <Form>
            <Row className="mb-3 text-end">
              <Form.Group as={Col} md="6" controlId="chronic">
                <Form.Label className='w-100'>{currentLocal.home.chronicillnesses}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="chronic"
                  value={studentInf?.chronic_diseases}
                  disabled
                  className="bg-light border-0 rounded-3"
                />
              </Form.Group>

              <Form.Group as={Col} md="6" controlId="allergy">
                <Form.Label className='w-100'>{currentLocal.home.particularfood}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="allergy"
                  value={studentInf?.food_allergies}
                  disabled
                  className="bg-light border-0 rounded-3"
                />
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} controlId="notes">
                <Form.Label>{currentLocal.home.Othernotes}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="notes"
                  value={studentInf?.other_notes}
                  disabled
                  className="bg-light border-0 rounded-3"
                />
              </Form.Group>
            </Row>
          </Form>
        </div>
        <div className='mt-5'>
          <h5 className='text-danger'>{currentLocal.home.Transportation}</h5>

          {/* نوع النقل */}

          <div className="d-flex justify-content-start mb-4 gap-3 form-check form-check-reverse">


            <Form.Check id="transport1" type="radio" label={currentLocal.home.Schooltransportation} name="transportType" value="school_bus" checked={studentInf?.transport === "school_bus"} disabled inline />
            <Form.Check id="transport2" type="radio" label={currentLocal.home.Privatetransportation} name="transportType" value="private_bus" checked={studentInf?.transport === "private_bus"} disabled inline />
          </div>
          <Container fluid>
            <Row>
              <Col md={4}>
                <CustomInput name="phone" value={studentInf?.state?.governorate?.name} />

                {/* <select value={governoratId}  className=' bg-light border-0 rounded-3 mb-3' style={{ height: '50px' }}>
                  <option  >{currentLocal.home.governorates}</option>

                  {governoratesState.map((item) => {
                    return (
                      <option value={item?.value}>{item?.label}</option>

                    )
                  })}
                </select> */}
              </Col>
              <Col md={4}>
                <CustomInput name="phone" value={studentInf?.state?.name} />

              </Col>
              <Col md={4}>
                <Form.Group as={Col} controlId="streetNumber"><CustomInput name="regionId" value={studentInf?.region_id} placeholder={currentLocal.home.region_id} /></Form.Group>

              </Col>
            </Row>
          </Container>



          {/* <select value={regionId} onChange={(e) => setregionId(e.target.value)} className='form-control bg-light border-0 rounded-3 mb-3' style={{ height: '50px' }}>

              {regionsState.map((item) => {
                return (
                  <option value={item?.value}>{item?.label}</option>

                )
              })}
            </select> */}



          <Form>
            <Row className="mb-3 text-end">
              <Form.Group as={Col} md="4" controlId="streetNumber"><Form.Label>{currentLocal.home.Tracknumber}</Form.Label><CustomInput name="streetNumber" value={studentInf?.street_number} /></Form.Group>
              <Form.Group as={Col} md="4" controlId="houseNumber"><Form.Label>{currentLocal.home.Housenumber}</Form.Label><CustomInput name="houseNumber" value={studentInf?.house_number} /></Form.Group>
              <Form.Group as={Col} md="4" controlId="nearestPlace"><Form.Label>{currentLocal.home.Nearestknownlocation}</Form.Label><CustomInput name="nearestPlace" value={studentInf?.nearest_landmark} /></Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} controlId="mapLink">
                <Form.Label>{currentLocal.home.Linklocation} (Google Maps)</Form.Label>
                <CustomInput name="mapLink" value={studentInf?.home_location_url} />
              </Form.Group>
            </Row>
          </Form>
        </div>


        <Row>
              {rows.map((item, index) => (
                <Col md={6} key={index}className='mb-4'>
                  <div className=' mb-3 '>
                    <label className="px-4 mb-2">
{item?.label}                
                    </label>
<img src={studentInf?.[item?.key]} alt='' className='w-100'
                onClick={() => openModal(studentInf?.[item?.key])} // Open modal on image click
                style={{ cursor: 'pointer' }} // Show cursor as pointer

/>
        
                  </div>
                </Col>
              ))}
            </Row>

















        {/* <div className='mt-5'>
          {userinfo?.role != "Student" &&
            <label className='text-danger fw-bold mb-3'>{currentLocal.home.files}</label>
          }
          {userinfo?.role != "Student" &&

            <Row>
              {rows.map((item, index) => (
                <Col md={6} key={index}>
                  <div className='d-flex justify-content-between mb-3 align-items-center'>
                    <label className="btn btn-pink text-white px-4">
                      {currentLocal.home.Upload}
                      <input
                        type="file"
                        onChange={(e) => handleFileChange(e, item.key)}
                        hidden
                        accept="image/*,application/pdf"
                      />
                    </label>
                    <input
                      type="text"
                      className="form-control bg-light text-end"
                      placeholder={currentLocal.language == "العربيه" ? item.label : item.label_en}
                      // عرض اسم الملف الذي تم اختياره (إذا كان موجوداً)
                      value={files[item.key] ? files[item.key].name : ""}
                      readOnly
                      style={{ width: '70%' }}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          }
        </div> */}

        <style>{`
          input[type="radio"], input[type="checkbox"] {
            accent-color: #ff5b8f;
          }
          .form-label, label {
            font-weight: 500;
            color: #001b35;
          }
          .btn-pink {
            background-color: #ff5b8f;
            border: none;
            border-radius: 10px;
            font-weight: bold;
          }
          .btn-pink:hover {
            background-color: #ff3f7e;
          }
        `}</style>
      </Container>
            {showModal && (
                  <Modal
show={showModal}  

size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
  
      <Modal.Body>
          <div className='modal-content'>
            <img src={selectedImage} alt='Selected' className='modal-image' />

</div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={()=>{
              const link = document.createElement('a'); // Create a new <a> element
    link.href = selectedImage; // Set the image source as the href
    link.download = selectedImage.split('/').pop(); // Set the file name to the last part of the URL
    link.click(); // Trigger the download

        }}>{currentLocal.home.download}</Button>
        <Button onClick={()=>setShowModal(false)}>{currentLocal.home.close}</Button>
      </Modal.Footer>
    </Modal>

//         <div className='modal' style={ {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     zIndex: 1050,
//   }} onClick={closeModal}>
//           <div className='modal-content'>
//             <img src={selectedImage} alt='Selected' className='modal-image' />
//             <a
//               href={selectedImage}
//               download
//               className='btn btn-primary'
//               style={
//                 {    marginTop: '10px',
// }
//               }
//             >
//               {currentLocal.home.download}
//             </a>
//           </div>
//         </div>
            )}
    </div>
  )
}

export default StudentDataContainer
